module.exports = __webpack_public_path__ + "img/incident_proteccion_civil_selected.2f2fa597.svg";